import { Button, Divider, Stack } from '@mui/material';
import { ArrowCounterClockwiseIcon } from '@phosphor-icons/react';
import { type FlowFilterCondition, FlowFilterMatchRule } from 'flow-schema';

import { Text } from 'common';

import { FilterConditionFields } from './FilterConditionFields.tsx';
import { LimitBlockFormFields } from './LimitFormFields.tsx';
import { SortBlockFormFields } from './SortFormFields.tsx';
import { FILTER_BLOCK_MATCH_RULE_NAMES } from './constants.ts';
import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate.tsx';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField.ts';

export function FilterBlockFormFields() {
  const { value: filterMatchRule, setValue: setFilterMatchRule } =
    useSelectedNodeField<FlowFilterMatchRule>('config.filterConfig.filterMatchRule');
  const { value: filterConditions } = useSelectedNodeField<FlowFilterCondition[]>(
    'config.filterConfig.filterConditions'
  );

  return (
    <>
      <BlockValueTemplateField
        fieldName="config.originalList"
        label="List to filter"
        placeholder="{{patient.data}}"
        required={true}
      />
      <Stack gap={1}>
        <Stack direction="row" gap={0.5} alignItems="center">
          <Text variant="heading5" bold>
            Conditions match
          </Text>
          {!!filterConditions?.length && (
            <Button
              variant="text"
              size="small"
              sx={{
                minWidth: 'unset',
                paddingY: 0,
                paddingX: 0.25,
                gap: 0.5,
                fontSize: (theme) => theme.typography.h4.fontSize,
                lineHeight: (theme) => theme.typography.h4.lineHeight,
              }}
              onClick={() => {
                setFilterMatchRule(
                  filterMatchRule === FlowFilterMatchRule.All
                    ? FlowFilterMatchRule.Any
                    : FlowFilterMatchRule.All
                );
              }}
            >
              {FILTER_BLOCK_MATCH_RULE_NAMES[filterMatchRule ?? FlowFilterMatchRule.All]}
              <ArrowCounterClockwiseIcon size={12} />
            </Button>
          )}
        </Stack>

        <FilterConditionFields setFilterMatchRule={setFilterMatchRule} />

        <Divider sx={{ marginY: 2 }} />
        <Stack gap={3}>
          <Text variant="heading5">Sorting</Text>
          <SortBlockFormFields />
        </Stack>

        <Divider sx={{ marginY: 2 }} />
        <Stack gap={3}>
          <Text variant="heading5">Limiting</Text>
          <LimitBlockFormFields />
        </Stack>
      </Stack>
    </>
  );
}
